// extracted by mini-css-extract-plugin
export default {"header":"GlPfOJJSey","logo":"UOV2ScVHv4","description":"RSUHofSZm0","dark":"MNDGwGTYg1"};